import React from 'react';
import type { UseToastOptions } from '@chakra-ui/react';
import { GlassToast } from './GlassToast';

const glassToastDefaultOptions: UseToastOptions = {
  position: 'top',
  duration: 5000,
  isClosable: true,
  containerStyle: {
    minWidth: 'min(100%, 260px)',
    maxWidth: 'min(560px, calc(100vw - 24px))',
  },
  render: (props) => <GlassToast {...props} />,
};

/**
 * Opciones globales de toast: glassmorphism, posición superior, contenedor responsive.
 * Pasar a `ChakraProvider` como `toastOptions={orgcloudGlassToastOptions}`.
 */
export const orgcloudGlassToastOptions = {
  defaultOptions: glassToastDefaultOptions,
};
